import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import { Text, tokens } from '@fhs/ui';

interface IPaymentEntryProps {
  icon: React.ReactNode;
  text?: string | React.ReactNode;
  textReplacement?: React.ReactNode;
  selected: boolean;
  onPress: () => void;
  testID?: string;
  disabled?: boolean;
}

export default function PaymentEntry({
  icon,
  text,
  textReplacement,
  selected,
  onPress,
  testID,
  disabled = false,
}: IPaymentEntryProps) {
  return (
    <Pressable
      testID={testID}
      style={styles.row}
      onPress={onPress}
      disabled={disabled}
    >
      <View style={styles.innerRow}>
        <View style={styles.iconCircle}>{icon}</View>
        {text ? (
          <Text.Ui weight="semibold" size="lg">
            {text}
          </Text.Ui>
        ) : (
          textReplacement
        )}
      </View>

      {disabled ? (
        <View
          style={[
            styles.radioDisabled,
            selected && styles.radioDisabledSelected,
          ]}
        />
      ) : selected ? (
        <View style={styles.radioSelected} />
      ) : (
        <View style={styles.radioUnselected} />
      )}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  row: {
    borderBottomColor: tokens.colors.$black10,
    borderBottomWidth: 1,
    width: '100%',
    minHeight: 64,
    paddingHorizontal: 32,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },

  innerRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },

  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
    marginRight: 12,
  },

  radioSelected: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 5,
    borderColor: tokens.colors.$houseRed,
    alignItems: 'center',
    justifyContent: 'center',
  },

  radioUnselected: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity30,
  },

  radioDisabled: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    backgroundColor: tokens.colors.$blackOpacity04,
  },

  radioDisabledSelected: {
    borderColor: tokens.colors.$transparent,
  },
});
